import { createService } from "~/hocs/crud";
import * as model from "./model";

const getDefinedLegendGuid = (record) => {
    return {
        ownerDefinedLegendGuid: record.ownerDefinedLegendGuid,
    };
};

export const service = createService({
    _defaultLabels: {
        [model.PROPS_CAN_DELETE]: {
            visible: false,
            label: "canDelete",
            gridCol: 5,
            className: "col-shift-15",
        },
        [model.PROPS_LAYER_TYPE_NAME]: {
            label: "layerType",
            gridCol: 20,
        },
        [model.PROPS_LOCATION]: {
            label: "location",
            gridCol: 40,
        },
        [model.PROPS_DL_ATTRIBUTE_NAME]: {
            label: "attributeName",
            gridCol: 20,
        },
        [model.PROPS_CROP_NAME]: {
            label: "crop",
            gridCol: 20,
        },
        [model.PROPS_DL_CROP_PURPOSE_NAME]: {
            label: "cropPurposeName",
            gridCol: 20,
        },
        [model.PROPS_DL_PRODUCT_NAME]: {
            label: "productName",
            gridCol: 30,
        },
    },
    getGuid: getDefinedLegendGuid,
    guid: "ownerDefinedLegendGuid",
    id: "ownerDefinedLegend",
    recordName: "ownerDefinedLegendGuid",
    defaultSort: {
        FieldName: "LayerTypeName",
        Sort: {
            Direction: "ASC",
            Order: 0,
        },
    },
});
